import React from "react";
import Header from "./Header";
import LeftNavbar from "../global/LeftNavbar";
import { useNavigate, useParams } from "react-router-dom";
import { navigateBack } from "../../AppIcons";
import ProjectDetailsTab from "./ProjectDetailTab";
import ProjectDatesTab from "./ProjectDatesTab";
import BidsAndCommissions from "./BidsAndCommissions";
import APIUrls from "../../services/APIUrls";
import { useEffect, useState } from "react";
import { getAxiosResponse } from "../../services/authApiRoutes/APImethods";
import Constants from "../../Constants";
import PaymentStatusTab from "./PaymentStatusTab";
import { useTranslation } from "react-i18next";
import { RotatingLines } from "react-loader-spinner";
import { ConditionalBlock } from "../../ConditionalBlock";


export default function ProjectDetails() {
  const param = useParams();
  const navigate = useNavigate();
  const [data, updateProjectDetail] = useState();
  const [activeTab, setActiveSection] = useState("projectDetail");
  const [paymentDataChanged, setPaymentDataChanged] = useState(true);
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation();

  useEffect(() => {
    if (paymentDataChanged) {
      getAxiosResponse(APIUrls.PROJECT_DETAIL_TAB_FINANCE(param.id))
        .then((res) => {
          updateProjectDetail(res.data);
          setLoading(false);
        })
        .catch((err) => {
          console.error(err);
        });

      setPaymentDataChanged(false);
    }
  }, [paymentDataChanged]);

  const getState = () => {
    let state = {
      retainFilter: true,
    };
    return ({ state });
  };

  const noDataFoundComponent = () => {
    return (
      <div role="rowgroup">
        <div role="row" className="no-data-display align-center">
          <div role="cell">
            <i className="nodata-icon"></i>
            <p>{Constants.NO_RECORD_FOUND}</p>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="body bg-color">
      <div id="container" className="dashboard-wrapper tourslider-dots">
        <Header />
        <LeftNavbar />
        <div id="content" className="dashboard-wrap campaign-section">
          <section className="dashboard-content">
            <div className="wrap-data">
              <div className="white-bg project-detail-page">
                <div className="project_details-overview flex">
                  <div className="left-content main">
                    {data?.projectId
                      ? (
                        <><div className="left-content-header">
                          <div className="name-card-section">
                            <div className="name-card-section-left">
                              <div className="campaign-name">
                                <button
                                  aria-label="back"
                                  className="back-btn"
                                  onClick={() => navigate("/finance/projects", getState())}
                                >
                                  {navigateBack}
                                </button>
                                <h3>{data?.projectName}</h3>
                              </div>
                              <div className="refresh-outer refresh-outer-right flex-center">
                                <div className="progress progress-green">{data?.projectStatus}</div>
                              </div>
                            </div>
                          </div>
                          <div className="listing-tab-block flex">
                            <ul className="listing-tab-link flex" role="tablist">
                              <li role="none">
                                <button
                                  role="tab"
                                  aria-label="projectDetail"
                                  aria-selected={activeTab === "projectDetail" ? true : false}
                                  className={activeTab === "projectDetail" ? "active" : ""}
                                  onClick={() => setActiveSection("projectDetail")}
                                >
                                  {t("finance.project_details")}
                                </button>
                              </li>

                              <li role="none">
                                <button
                                  role="tab"
                                  aria-label="ProjectDates"
                                  aria-selected={activeTab === "ProjectDates" ? true : false}
                                  className={activeTab === "ProjectDates" ? "active" : ""}
                                  onClick={() => setActiveSection("ProjectDates")}
                                >
                                  {t("finance.project_dates")}
                                </button>
                              </li>

                              <li role="none">
                                <button
                                  role="tab"
                                  aria-label="BidsCommissions"
                                  aria-selected={activeTab === "BidsCommissions" ? true : false}
                                  className={activeTab === "BidsCommissions" ? "active" : ""}
                                  onClick={() => setActiveSection("BidsCommissions")}
                                >
                                  {t("finance.bids_commissions")}
                                </button>
                              </li>

                              <li role="none">
                                <button
                                  role="tab"
                                  aria-label="PaymentStatus"
                                  aria-selected={activeTab === "PaymentStatus" ? true : false}
                                  className={activeTab === "PaymentStatus" ? "active" : ""}
                                  onClick={() => setActiveSection("PaymentStatus")}
                                >
                                  {t("finance.payment_status")}
                                </button>
                              </li>
                            </ul>
                          </div>
                        </div><>
                            {(() => {
                              switch (activeTab) {
                                case "projectDetail":
                                  return <ProjectDetailsTab data={data} />;
                                case "ProjectDates":
                                  return <ProjectDatesTab data={data} />;
                                case "BidsCommissions":
                                  return <BidsAndCommissions data={data} />;
                                case "PaymentStatus":
                                  return <PaymentStatusTab data={data} setPaymentDataChanged={setPaymentDataChanged} />;
                                default:
                                  return noDataFoundComponent();
                              }
                            })()}
                          </></>
                      ) : noDataFoundComponent()}
                  </div>
                  <ConditionalBlock condition={loading}>
                    <div className={"gb-overlay show"}>
                      <div className="gb-loader">
                        <RotatingLines
                          strokeColor="#0096FF"
                          strokeWidth="5"
                          width="196"
                          visible={true}
                        />
                      </div>
                    </div>
                  </ConditionalBlock>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
